import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";

import "@/index.less";
import App from "@/App";
import reportWebVitals from "@/reportWebVitals";
import { store, persistor } from "@/store/configureStore";

import "@/assets/svg"; // 引入svg

// mock会修改axios获取的内容，尤其是二进制文件内容，排查问题时需要注意
// import "@/mock/index.ts";

switch (process.env.NODE_ENV) {
  case "development":
    // require("./mock/index.ts");
    break;
  default:
    break;
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <React.StrictMode> */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* </React.StrictMode> */}
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
